import { MouseEvent, ReactElement, useEffect, useState } from "react";
import { Box } from "@twilio-paste/core/box";
import EndChatButton from "./sub/EndChatButton/EndChatButton";
import chatService from "../../services/conversations/conversationsService";
import { ConversationEvents } from "../../services/conversations/definitions/constants";
import { ConversationUpdatedEventArgs, JSONValue } from "@twilio/conversations";
import { getAttribute } from "../../utils";
import { LiveChatPhaseEnum } from "@twiliointernal/e2-commons-shared-definitions";
import {
  ConversationServiceReadyEvent,
  chatEndedByValue,
} from "../../services/conversations/definitions/types";
import { LiveChat } from "../../views";

const EndChat = (): ReactElement => {
  const [visible, setVisible] = useState(false);
  const [chatEndedBy, setChatEndedBy] = useState<chatEndedByValue>("position");

  useEffect(() => {
    chatService.addEventListener(
      ConversationEvents.Updated,
      handleConversationUpdated
    );
    chatService.addEventListener(
      ConversationEvents.Ready,
      handleConversationReady
    );

    return () => {
      chatService.removeEventListener(
        ConversationEvents.Updated,
        handleConversationUpdated
      );
      chatService.removeEventListener(
        ConversationEvents.Ready,
        handleConversationReady
      );
    };
  }, []);

  // Callback for when the conversation data is updated
  const handleConversationUpdated = (event: ConversationUpdatedEventArgs) => {
    updateVisibility(event.conversation?.attributes);
  };

  const handleConversationReady = (event: ConversationServiceReadyEvent) => {
    updateVisibility(event.attributes);
  };

  const updateVisibility = (conversationAttributes?: JSONValue) => {
    if (conversationAttributes) {
      const currentChatPhase = getAttribute({
        attributes: conversationAttributes,
        key: "chatPhase",
      });

      setVisible(currentChatPhase !== LiveChatPhaseEnum.Ended);
      setChatEndedBy(LiveChatPhaseEnum.Waiting ? "position" : "client");
    }
  };

  const handleConfirm = async (event: MouseEvent<HTMLButtonElement>) => {
    return chatService.endLiveChat(chatEndedBy);
  };

  return visible ? (
    <Box marginBottom={"space50"}>
      <EndChatButton onConfirm={handleConfirm} />
    </Box>
  ) : (
    <></>
  );
};

export default EndChat;
